<template>
  <b-row>
    <b-col>
      <video-row
        v-for="(aVideo, i) in videos"
        :video="aVideo"
        :key="`vid-${i}`"
      />
    </b-col>
  </b-row>
</template>

<script>
import VideoRow from "./videoRow";
import VueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
export default {
  name: "Display_Monitor",
  components: {
    VideoRow,
    VueCustomScrollbar
  },
  created() {},
  mounted() {},
  props: {
    videos: {
      type: Array,
      required: false,
      default: () => []
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    rootPathCollection: {
      type: String,
      default: "rtcs"
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    input() {
      return "";
    },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        provider: this.providerData,
        resource: this.resource,
        settings: this.settings,
        userData: this.userData,
        rootPathCollection: this.rootPathCollection
      };
    }
  },
  methods: {
    handleGenerateClick() {
      this.$emit("generate-click", this.input);
    },
    scrollHandle(evt) {
      console.log(evt);
    }
  },
  data() {
    return {
      tabs: {
        isPills: false,
        isSmall: true,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: false
      },
      tab: {
        titleLinkAttributes: {
          color: "#5695e0"
        },
        hexColorTabBg: "#777",
        hexColorTabText: "#777",
        hexColorScreen: "#777"
      },
      sections: [
        {
          id: "devices",
          title: "Devices",
          component: LiveMonitors,
          componentName: "LiveMonitors",
          avail: true
        },
        {
          id: "clips",
          title: "Clips",
          component: VideoRow,
          componentName: "VideoRow",
          avail: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
